module.exports = "/_next/static/images/monitor-duotone-dbbfd55f4087ab1e1bbceb005adb8c3f.svg";